import React, { useEffect, useState } from 'react'
import logo from '../../assets/images/allira-logo.png'
import auth from '../../assets/images/authentication/img-auth-sideimg.jpg'
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { postData } from '../Services/api';

const Login = () => {
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const [values, setValues] = useState({
        email: "",
        password: "",
    })
    const token = localStorage.getItem("token")
    useEffect(() => {
        if (token) {
            navigate('/')
        }
    }, [])
    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    }

    const toggleVisibility = () => {
        setShowPassword(!showPassword);
    }
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    const validateLogin = () => {
        const { email, password } = values;
        const toastId = "email-Id"
        if (!email?.trim()) {
            if (!toast.isActive(toastId)) {
                toast.error('Please Enter valid email', {
                    toastId: toastId
                });
            }
            return false;
        }
        if (!emailRegex.test(email)) {
            toast.error('Please enter a valid email address');
            return false;
        }
        if (!password) {
            if (!toast.isActive(toastId)) {
                toast.error('Please Enter Password', { toastId: toastId });
            }
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateLogin()) {
            setLoading(true)
            try {
                const res = await postData(`/auth/login`, values)
                if (res.status) {
                    localStorage.setItem("token", res.token)
                    localStorage.setItem("user", JSON.stringify(res.user))
                    toast.success(res.message)
                    navigate('/')
                    setValues({
                        email: "",
                        password: "",
                    });
                    setLoading(false)
                } else {
                    setLoading(false)
                    toast.error(res.message)
                }
            } catch (error) {
                setLoading(false)
                console.log("error login", error)
                toast.error(error?.response?.data?.error)
            }
        }
    }
    return (
        <div className="auth-main">
            <div className="auth-wrapper v2">
                <div className="auth-sidecontent">
                    <img
                        src={auth}
                        alt="images"
                        className="img-fluid img-auth-side"
                    />
                </div>
                <div className="auth-form">
                    <div className="card my-5">
                        <div className="card-body">
                            <div className="text-center mb-5">
                                <Link to="#">
                                    <img src={logo} width={100} height={100} alt="img" />
                                </Link>
                            </div>
                            <h4 className="text-center f-w-500 mb-3">Login with your email</h4>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group mb-3">
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="floatingInput"
                                        placeholder="Email Address"
                                        name='email'
                                        value={values.email}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="input-group">
                                    <input
                                        type={!showPassword ? "password" : "text"}
                                        name="password"
                                        value={values.password}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder='*******'
                                        required
                                    />
                                    <span className="input-group-text" onClick={toggleVisibility}
                                        style={{ cursor: 'pointer' }} id="validationTooltipUsernamePrepend">
                                        <i className={`fa ${!showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    </span>
                                </div>
                                <div className="d-grid mt-4">
                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            "Sign In"
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Login